import styled from 'styled-components';

import { OnboardingPage } from '@/pages/Onboarding/components/Page';

export const PageStyles = styled(OnboardingPage)`
  --background: url('/assets/layout-own-ai-man/lonely-nights.png') no-repeat
    center center / cover;

  .title {
    margin-bottom: 0;
  }

  ion-content {
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: url('/assets/layout-own-ai-man/overlay-shadow.png') no-repeat
        center center / cover;
      z-index: 1;
      pointer-events: none;
    }

    &::part(scroll) {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-end;
      height: 100%;
      padding-bottom: 34px;
      position: relative;
      z-index: 2;
    }
  }
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-top: auto;
  position: relative;
  z-index: 2;
`;
